import {Directive} from '@angular/core';
import {FormControl, NG_VALIDATORS} from "@angular/forms";
import {join, uniq} from 'lodash-es';

export function whitelistCharacterValidator(control: FormControl) {
  let input = control.value;
  if (input == null || input.trim() === "") {
    return null;
  }

  const regexpNumber = new RegExp(/^[\p{Ll}\p{Lu}\p{Nd},-.()|+!#@&’/:;"'\r\n ]+$/ug);

  let message = 'You have entered invalid characters';
  try {
    const illegalCharacters = input.replace(/[\p{Ll}\p{Lu}\p{Nd},-.()|+!#@&’/:;"'\r\n ]+/ug, '').split('');
    message += ': ' + join(uniq(illegalCharacters), ' ');
  } catch (err) {
    console.log(err);
  }

  if (!regexpNumber.test(input)) {
    return {
      blacklistedCharacter: true,
      illegalCharacters: message
    };
  }
  return null;
}

@Directive({
    selector: '[validCharacterValidator][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useValue: whitelistCharacterValidator, multi: true }
    ],
    standalone: false
})
export class ValidCharacterValidatorDirective {

  constructor() {
  }

}
